import { Id, LaravelResponse, ModelUsageResource, createCrudService, keyToUrl } from "@dgs/core";
import axios from "axios";
import {
	UserResponsibilityResource,
	UserResponsibilitySaveRequest,
	UserResponsibilityUpdateResource,
} from "../types/userResponsibility";

const baseKey = ["user-responsibilities"];

const showUsageKey = (responsibilityId: Id) => [...baseKey, `${responsibilityId}`, "usages"];

export const userResponsibilityService = {
	...createCrudService<
		UserResponsibilityResource,
		UserResponsibilityResource,
		UserResponsibilityUpdateResource,
		UserResponsibilitySaveRequest
	>(baseKey),
	showUsageKey,
	showUsage: (responsibilityId: Id) =>
		axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(responsibilityId))),
};
